import { LabelValue } from '@/types/global';
import { Translator } from '@/types/translator.type';

export const ACTIVITY_DUPLICATION_FIELDS = (t: Translator) => [
  {
    label: t('benefits.duplicationFields.generalInfo'),
    value: 'name;supplier;currency;country;city;marginRate',
  },
  {
    label: t('benefits.duplicationFields.descriptions'),
    value: 'shortDescription;longDescription;images',
  },
  {
    label: t('benefits.duplicationFields.tarification'),
    value: 'tarifType;specialTarif;childAgeFrom;childAgeTo;pricings',
  },
];

export const VEHICLE_WITH_CHAUFFEUR_DUPLICATION_FIELDS = (t: Translator) => [
  {
    label: t('benefits.duplicationFields.generalInfo'),
    value: 'name;supplier;currency;country;marginRate',
  },
  {
    label: t('benefits.duplicationFields.vehicleInformation'),
    value: 'model;shortDescription;longDescription;images;maxCapacity',
  },
  {
    label: t('benefits.duplicationFields.tarification'),
    value: 'pricings',
  },
];

export const CAR_RENTAL_DUPLICATION_FIELDS = (t: Translator) => [
  {
    label: t('benefits.duplicationFields.generalInfo'),
    value: 'name;supplier;currency;country;city;marginRate;displayGlobalForm',
  },
  {
    label: t('benefits.duplicationFields.complementaryInsurances'),
    value: 'shouldLimitInsurance;insurances',
  },
  {
    label: t('benefits.duplicationFields.options'),
    value: 'options',
  },
  {
    label: t('benefits.duplicationFields.taxes'),
    value: 'taxes',
  },
  {
    label: t('benefits.duplicationFields.oneWayFees'),
    value: 'oneWayFees',
  },
];

export const FLIGHT_DUPLICATION_FIELDS = (t: Translator) => [
  {
    label: t('benefits.duplicationFields.generalInfo'),
    value: 'name;supplier;currency;country;marginRate',
  },
  {
    label: t('benefits.duplicationFields.destinations'),
    value:
      'sourceCountry;sourceCity;sourceAirport;destinationCountry;destinationCity;destinationAirport',
  },
  {
    label: t('benefits.duplicationFields.descriptions'),
    value: 'shortDescription;longDescription',
  },
  {
    label: t('benefits.duplicationFields.tarification'),
    value: 'pricings;specialTarif;childAgeFrom;childAgeTo',
  },
];

export const HOTEL_DUPLICATION_FIELDS = (
  t: Translator,
): LabelValue<string>[] => [
  {
    label: t('benefits.duplicationFields.generalInfo'),
    value: 'name;category;chain;supplier;currency;country;marginRate',
  },
  {
    label: t('benefits.duplicationFields.address'),
    value: 'address;city;postalCode;latitude;longitude',
  },
  {
    label: t('benefits.duplicationFields.contacts'),
    value:
      'contactNames;contactPhones;contactWebsite;contactMainEmail;contactReservationsEmail;contactStockAlertEmail;contactSecondaryEmails',
  },
  {
    label: t('benefits.duplicationFields.descriptions'),
    value:
      'mainImage;images;shortDescriptionTitle;shortDescriptionBody;longDescriptionTitle;longDescriptionBody',
  },
  {
    label: t('benefits.duplicationFields.complementaryInfo'),
    value:
      'pricingType;reducedPriceExists;isReduction;acceptsChildPricing;childAgeFrom;childAgeTo;secondChildAgeFrom;secondChildAgeTo;pricingPensionType;shouldFillOtherPensionTypes;areOtherPensionPricesCommon;commonPensionPricings;shouldFillHotelSupplements;hotelSupplements',
  },
  {
    label: t('benefits.duplicationFields.associatedBenefits'),
    value: 'shouldAssociateBenefits;associatedBenefits',
  },
];
